import { productSvcApi } from '@ctct/infrastructure-layer';

import { EntitlementResponseSchema } from './schemas';
import { Entitlement } from '../../value-objects';
import { zodService } from '../ZodService';

class ProductRepo {
  public async getEntitlements(feature: string, activity: string) {
    const response = await productSvcApi.getEntitlements(feature, activity);

    const data = zodService.safeParse(EntitlementResponseSchema, response.data);

    const entitlement = new Entitlement(data);

    return entitlement;
  }
}

export const productRepo = new ProductRepo();
